import React, { useState, useEffect } from 'react';
import { compatAPI } from '../../utils/api';

export default function UnknownOuiPage() {
    const [ouis, setOuis] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        compatAPI.getUnknownOuis()
            .then(res => {
                const d = res.data;
                const rows = Array.isArray(d) ? d
                           : Array.isArray(d?.unknowns) ? d.unknowns
                           : Array.isArray(d?.rows) ? d.rows
                           : Array.isArray(d?.data) ? d.data
                           : [];
                setOuis(rows);
            })
            .catch(err => console.error('Unknown OUI error:', err))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="text-gray-400">Loading...</div>;

    return (
        <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Unknown OUIs</h2>
            <div className="bg-white rounded-lg shadow-md p-6">
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">OUI Prefix</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Occurrences</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">First Seen</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Last Seen</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {ouis.map((oui, idx) => (
                                <tr key={idx} className="hover:bg-gray-50">
                                    {/* Backend SQL aliases the column as mac_oui; older clients used oui_prefix/oui. */}
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-mono font-medium text-gray-900">{oui.mac_oui || oui.oui_prefix || oui.oui || '-'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{oui.occurrences ?? oui.count ?? 0}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {oui.first_seen ? new Date(oui.first_seen).toLocaleString() : '-'}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {oui.last_seen ? new Date(oui.last_seen).toLocaleString() : '-'}
                                    </td>
                                </tr>
                            ))}
                            {ouis.length === 0 && (
                                <tr><td colSpan="4" className="px-6 py-6 text-sm text-gray-400 text-center">No unknown OUIs</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
